import {
  ASSET_LIST,
  ASSET_REGISTER_REPORT,
  ASSIGNMENT_HISTORY_REPORT,
  BRAND_LIST,
  CATEGORY_LIST,
  COST_SUMMARY_REPORT,
  DASHBOARD,
  DEPARTMENT_LIST,
  DEPARTMENT_WISE_REPORT,
  DESIGNATION_LIST,
  EMPLOYEE_LIST,
  HELP,
  INVENTORY_ITEM_LIST,
  LICENSE_EXPIRY_LIST,
  LOCATION_LIST,
  LOCATION_WISE_REPORT,
  LOW_STOCK_LIST,
  MODEL_LIST,
  PURCHASE_ORDER_LIST,
  REPAIR_HISTORY_REPORT,
  SOFTWARE_LICENSE_LIST,
  VENDOR_LIST,
  WARRANTY_EXPIRY_LIST,
} from '@constants/internal-route.constant'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {MASTERDATA_ROUTES, REPORTS_ROUTES} from './menu-routes'

// The whole itam navigation (docs/itam-ui-alignment-plan.md, D1): Dashboard and the two primary
// workflows (Purchase Orders, Software Licenses) as top items, then Reports and Master Data, then
// Help. Feature items are `gated` (hidden without the feature grant: exact equality between the
// route constant and auth.features.url, the ERPBOI_ITAM catalog seeded in portal), each group is
// hidden when none of its children survive (menu-routes.ts), and a group's pages are listed A–Z by
// their label (SidebarMenuItemWithSub).
//
// There is no Audit group (removed 2026-10-18): change history is the portal's Audit logs.
//
// A group's `to` is only its open/closed key. Master Data starts open: Assets lives there.
//
// Notifications has no entry of its own: the header bell is the standard placement.
export const SidebarMenuMain = () => {
  return (
    <>
      <SidebarMenuItem to={DASHBOARD} title='Dashboard' fontIcon='bi-columns-gap' />
      <SidebarMenuItem gated to={PURCHASE_ORDER_LIST} title='Purchase Orders' fontIcon='bi-cart3' />
      <SidebarMenuItem
        gated
        to={SOFTWARE_LICENSE_LIST}
        title='Software Licenses'
        fontIcon='bi-key'
      />

      <SidebarMenuItemWithSub
        to='itam-reports'
        title='Reports'
        fontIcon='bi-bar-chart-line'
        anyOf={REPORTS_ROUTES}
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-pc-display'
          to={ASSET_REGISTER_REPORT}
          title='Asset Register'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-person-badge'
          to={ASSIGNMENT_HISTORY_REPORT}
          title='Assignment History'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-tools'
          to={REPAIR_HISTORY_REPORT}
          title='Repair History'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-3'
          to={DEPARTMENT_WISE_REPORT}
          title='Department-wise'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-geo-alt'
          to={LOCATION_WISE_REPORT}
          title='Location-wise'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-cash-coin'
          to={COST_SUMMARY_REPORT}
          title='Cost Summary'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-shield-exclamation'
          to={WARRANTY_EXPIRY_LIST}
          title='Warranty Expiry'
        />
        <SidebarMenuItem gated fontIcon='bi-key' to={LICENSE_EXPIRY_LIST} title='License Expiry' />
        <SidebarMenuItem
          gated
          fontIcon='bi-exclamation-triangle'
          to={LOW_STOCK_LIST}
          title='Low Stock'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='itam-masterdata'
        title='Master Data'
        fontIcon='bi-database'
        anyOf={MASTERDATA_ROUTES}
        defaultOpen
      >
        <SidebarMenuItem gated fontIcon='bi-pc-display' to={ASSET_LIST} title='Assets' />
        <SidebarMenuItem
          gated
          fontIcon='bi-box-seam'
          to={INVENTORY_ITEM_LIST}
          title='Inventory Items'
        />
        <SidebarMenuItem gated fontIcon='bi-tags' to={CATEGORY_LIST} title='Categories' />
        <SidebarMenuItem gated fontIcon='bi-bookmark' to={BRAND_LIST} title='Brands' />
        <SidebarMenuItem gated fontIcon='bi-laptop' to={MODEL_LIST} title='Models' />
        <SidebarMenuItem gated fontIcon='bi-truck' to={VENDOR_LIST} title='Vendors' />
        <SidebarMenuItem gated fontIcon='bi-geo-alt' to={LOCATION_LIST} title='Office Location' />
        <SidebarMenuItem gated fontIcon='bi-diagram-3' to={DEPARTMENT_LIST} title='Departments' />
        <SidebarMenuItem
          gated
          fontIcon='bi-person-badge'
          to={DESIGNATION_LIST}
          title='Designations'
        />
        <SidebarMenuItem gated fontIcon='bi-people' to={EMPLOYEE_LIST} title='Employees' />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem to={HELP} title='Help' fontIcon='bi-question-circle' />
    </>
  )
}
